export const environment = {
  production: false,
  apiUrl: 'https://dev-api.einfachnurlernen.de/api',
  mediaBaseUrl: 'https://dev-api.einfachnurlernen.de/images',
  googleClientId: '629453906340-uc6m5pqlqtsn2t4oqqk4e409hj6rki5r.apps.googleusercontent.com'
};
